var _circle, _circle2, _circle3, _circle4, _line, _line2, _line3, _line4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4708,
    cy: 3.52941,
    r: 2.77941,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4708,
    cy: 16.4708,
    r: 2.77941,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.52941,
    cy: 3.52941,
    r: 2.77941,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.52941,
    cy: 16.4708,
    r: 2.77941,
    stroke: "black",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.75,
    y1: 6,
    x2: 16.75,
    y2: 14,
    stroke: "black",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.75,
    y1: 6,
    x2: 3.75,
    y2: 14,
    stroke: "black",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 16.25,
    x2: 14,
    y2: 16.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 3.25,
    x2: 14,
    y2: 3.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.5C9 8.99998 9 8.99998 10.5 10.5C11.7 11.7 13.6667 9.33333 14.5 8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceicon);
export default __webpack_public_path__ + "static/media/Financeicon.d521c29383c013c8b1c796fffb70818a.svg";
export { ForwardRef as ReactComponent };